import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20accessories%20sneakers%20and%20lifestyle%20products%20scattered%20organically%20on%20warm%20cream%20textured%20surface%2C%20soft%20diffused%20overhead%20lighting%2C%20editorial%20product%20photography%2C%20modern%20minimalist%20aesthetic%20with%20harmonious%20neutral%20color%20palette%2C%20clean%20negative%20space%20with%20artistic%20arrangement&width=1600&height=900&seq=hero-bg-v3&orientation=landscape"
        alt="AllChinaBuy Spreadsheet product collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs font-medium mb-6">
              <i className="ri-verified-badge-line"></i>
              <span>Updated Daily &bull; Trusted Sellers</span>
            </div>
            <h1 className="font-heading font-bold text-5xl md:text-7xl lg:text-8xl text-white leading-[1.08] tracking-tight">
              Best<br />
              AllChinaBuy<br />
              <span className="font-normal italic">Spreadsheet 2026</span>
            </h1>
            <p className="mt-6 text-white/80 text-base md:text-lg max-w-xl leading-relaxed">
              Discover trusted sellers, verified products, shipping guides, and the latest
              AllChinaBuy Spreadsheet updates — all in one place. Browse 1000+ products across 14 categories.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="#categories"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                Browse Spreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-white/15 backdrop-blur-sm text-white font-semibold text-sm border border-white/25 hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
              >
                Visit Main Site
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          <div className="hidden lg:flex flex-col gap-2 text-white/70 text-xs font-medium">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>Verified Sellers</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>QC & Shipping Tips</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>Safe Buying Guides</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-primary-400"></i>
              <span>Updated Daily</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}